import GroupLogo from './GroupLogo.presenter';
import GroupLogoWithDefault from './GroupLogoWithDefault';

export {
  GroupLogoWithDefault,
};

export default GroupLogo;